const FooterBottom = () => {
  return (
    <>
      <section
        className="footer-bottom text-light pt-5 pb-5"
        data-bgcolor="#18191b"
      >
        <div className="container">
          <div
            className="align-items-center"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <div
              className="col-md-6 text-center"
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <a href="http://rstcom.com.br/" target="_blank">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/images%2Flogo-rstcom.png?alt=media&token=b80e35ff-d708-440b-85a6-ae7465d95179"
                  width={35}
                />
                <br />
              </a>
              <medium>Plataforma de transmissão completa de eventos.</medium>
            </div>
            <div className="col-md-6 text-center align-items-center mt-4 mt-md-0">
              <p className="text-light mb-0">
                Problemas com a conexão / áudio?
                <a href="https://rstcom.live/faq/rstcom/" target="_blank">
                  <br />
                  <span className="id-color"> Clique aqui</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FooterBottom;
